<div
    class="vehicle-detail-container flex flex-column justify-content-center align-items-center"
>
    <p-card class="w-full" [header]="getPolicyHeader()" *ngIf="policy">
        
        <div class="border-300 border-top-1 pt-4 flex flex-column">
            <div class="flex w-full flex-wrap">
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        policy.insuranceType | translate
                    }}</span>
                    <span class="text-500 text-sm">{{
                        "Insurance Type" | translate
                    }}</span>
                </div>
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        policy.status | translate
                    }}</span>
                    <span class="text-500 text-sm">{{
                        "Policy Status" | translate
                    }}</span>
                </div>
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        policy.coverStartDate | date : "dd-MMM-yyyy"
                    }}</span>
                    <span class="text-500 text-sm">{{
                        "Cover Start Date" | translate
                    }}</span>
                </div>
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        policy.maturityDate | date : "dd-MMM-yyyy"
                    }}</span>
                    <span class="text-500 text-sm">{{
                        "Maturity Date" | translate
                    }}</span>
                </div>
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        policy.nextRenewalDate | date : "dd-MMM-yyyy"
                    }}</span>
                    <span class="text-500 text-sm">{{
                        "Next Renewal Date" | translate
                    }}</span>
                </div>
            </div>
            <p-divider></p-divider>
            <div class="my-4">
                <span class="text-xl text-600 font-bold">{{
                    "Insured vehicles" | translate
                }}</span>
            </div>
            <div>
                <p-table
                    [value]="policy.vehicles"
                    [paginator]="false"
                    [rows]="10"
                    *ngIf="
                        getDeviceType() === 'desktop' ||
                        getDeviceType() === 'tablet'
                    "
                >
                    <ng-template pTemplate="header">
                        <tr>
                            <th>{{ "VRN" | translate }}</th>
                            <th>{{ "MODEL" | translate }}</th>
                            <th>{{ "WEIGHT_CATEGORY" | translate }}</th>
                            <th>{{ "VEHICLE_USAGE" | translate }}</th>
                            <th>{{ "CARRYING_CAPACITY" | translate }}</th>
                            <th>{{ "VEHICLE_VALUE" | translate }}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-vehicle>
                        <tr>
                            <td>
                                <span class="p-column-title">VRN</span>
                                {{ vehicle.registrationNumber }}
                            </td>
                            <td>
                                <span class="p-column-title">Model</span>
                                {{ vehicle.model.make.name }} /
                                {{ vehicle.model.name }} /
                                {{ vehicle.yearOfManufacture }}
                            </td>
                            <td>
                                <span class="p-column-title"
                                    >Weight Category</span
                                >
                                {{ vehicle.weightCategory.name | translate }}
                            </td>
                            <td>
                                <span class="p-column-title">Use</span>
                                {{ vehicle.vehicleUse.description | translate }}
                            </td>
                            <td>
                                <span class="p-column-title"
                                    >Carrying Capacity</span
                                >
                                {{ vehicle.carryingCapacity }}
                            </td>
                            <td>
                                <span class="p-column-title"
                                    >Vehicle Value</span
                                >
                                {{
                                    vehicle.vehicleValue
                                        | currency : "MZN" + " "
                                }}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
                <ng-container *ngIf="getDeviceType() === 'mobile'">
                    <app-insured-vehicle-card
                        *ngFor="let vehicle of policy.vehicles"
                        [vehicle]="vehicle"
                    ></app-insured-vehicle-card>
                </ng-container>
            </div>
        </div>
    </p-card>
</div>
